<template>
  <div class="summary" v-if="importSummary">
    <b>Création du dossier de sélection "{{ name }}" par import de clés Gcoll2</b>
    <div>
      Import de <b>{{ totalN }}</b> ids du fichier externe, avec pour résultat <b>{{ totalNN }}</b> fiches Navigart3 (<b
        >{{ n1 }}</b
      >
      individuelles + <b>{{ n2 }}</b> éléments d'ensemble dissociable + <b>{{ totalSets }}</b> ensembles
      indissociables).
    </div>
    <div class="mb-2">Détail de l'import des ids par types de fiche:</div>
    <ul>
      <li v-if="n1">
        <b>{{ n1 }}</b> ids de fiches individuelles
      </li>
      <li v-if="n2">
        <b>{{ n2 }}</b> ids de fiches d'éléments d'ensemble dissociable
        <span
          v-translate="{ n2: n2, n6: n6 }"
          :translate-n="n6"
          translate-plural="(pour info, ces %{n2} fiches appartiennent à %{n6} ensembles différents)"
        >
          (pour info, ces %{n2} fiches appartiennent à 1 ensemble)
        </span>
      </li>
      <li v-if="n7">
        <b>{{ n7 }}</b> ids de fiches d'ensemble indissociable*
        <span
          v-translate="{ n7: n7, n8: n8 }"
          :translate-n="n7"
          translate-plural="(pour info, ces <b>%{n7}</b> ensembles représentent un total de <b>%{n8}</b> éléments)"
        >
          (pour info, cet ensemble représente un total de <b>%{n8}</b> éléments) </span
        ><br />
        *ou dissociable/N3=1 fiche (récape + liées)
      </li>
      <li v-if="n4">
        <b>{{ n4 }}</b> ids de fiches d'éléments d'ensembles indissociables*,
        <span
          v-translate="{ n3: n3 }"
          :translate-n="n3"
          translate-plural="représentant %{n3} ensembles indissociables différents"
        >
          représentant 1 ensemble indissociable </span
        ><br />
        *ou dissociable/N3=1 fiche (récape + liées)
      </li>
      <li v-if="n5">
        <b>{{ n5 }}</b> ids non trouvées,
        <a
          :download="`not_found-${name}totalSets.csv`"
          href=""
          @click.prevent.stop="downloadNotFound"
          ref="downloadNotFoundLink"
          target="_blank"
        >
          cliquez ici pour télécharger les ids correspondantes
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { parse } from 'json2csv';

export default {
  name: 'CartImportSummary',
  computed: {
    ...mapGetters('carts', ['importSummary']),
    name() {
      const { cart } = this.importSummary;
      return cart;
    },
    type() {
      const { type } = this.importSummary;
      const { separable = 0, nonseparable = 0, individual = 0 } = type;
      return { separable, nonseparable, individual };
    },
    n1() {
      return this.type.individual;
    },
    n2() {
      return this.type.separable;
    },
    n3() {
      return this.importSummary.nonseparable.elements.sets;
    },
    n4() {
      return this.importSummary.nonseparable.elements.ids;
    },
    notFoundIds() {
      return this.importSummary.not_found;
    },
    n5() {
      return this.importSummary.not_found.length;
    },
    n6() {
      return this.importSummary.separable;
    },
    n7() {
      return this.importSummary.nonseparable.headers.ids;
    },
    n8() {
      return this.importSummary.nonseparable.headers.elements;
    },
    totalN() {
      // n1 + n2 + n4 + n7 + n5
      return this.n1 + this.n2 + this.n4 + this.n7 + this.n5;
    },
    totalNN() {
      // n1 + n2 + n3 + n7
      return this.n1 + this.n2 + this.totalSets;
    },
    totalSets() {
      return this.n7 + this.n3;
    },
    downloadBlob() {
      const data = this.notFoundIds.map((id) => {
        return { id, blank: '' };
      });
      const fields = data.length > 0 ? ['id', 'blank'] : [];
      const options = {
        header: false,
        delimiter: ';',
        fields,
        quote: '',
        eol: '\r\n',
      };

      const blob = new Blob([parse(data, options)], { type: `data:text/csv;charset=utf-8;` });
      return blob;
    },
  },
  methods: {
    downloadNotFound(e) {
      const filename = this.$refs.downloadNotFoundLink.attributes.download.value;
      const blob = this.downloadBlob;

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        link.setAttribute('href', window.URL.createObjectURL(blob));
        link.setAttribute('download', filename);
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>
